import Admin from '@/components/Admin';
import ChartProgress from '@/components/ChartProgress.vue';
import CrudBoolean from '@/components/fields/Boolean.vue';
import CategoryHierarchySelect from '@/components/fields/CategoryHierarchySelect.vue';
import CategoryMultiSelect from '@/components/fields/CategoryMultiSelect.vue';
import CustomDateRangePicker from '@/components/fields/CustomDateRangePicker.vue';
import Image from '@/components/fields/Image.vue';
import ImageUpload from '@/components/fields/ImageUpload.vue';
import MailPreview from '@/components/fields/MailPreview.vue';
import MetaData from '@/components/fields/MetaData.vue';
import Radio from '@/components/fields/Radio.vue';
import RemoteSelect from '@/components/fields/RemoteSelect.vue';
import Select from '@/components/fields/Select.vue';
import Translations from '@/components/fields/Translations.vue';
import LoggedOut from '@/components/LoggedOut';
import Messages from '@/components/Messages.vue';
import Order from '@/components/Order.vue';
import Payment from '@/components/Payment.vue';
import Shipping from '@/components/Shipping.vue';
import VueCrudTable from '@/components/VueCrudTable.vue';
import Automation from '@/components/Automation.vue';
import General from '@/components/General.vue';
import PreviewImage from '@/components/PreviewImage.vue';
import Vue from 'vue';
import VueResource from 'vue-resource';
import Router from 'vue-router';
import Wysiwyg from 'vue-wysiwyg';
import Currency from '../libs/currency';

Vue.component('v-crud-radio', Radio);
Vue.component('v-crud-select', Select);
Vue.component('v-crud-boolean', CrudBoolean);
Vue.component('v-crud-remote-select', RemoteSelect);
Vue.component('v-crud-category-hierarchy-select', CategoryHierarchySelect);
Vue.component('v-crud-category-multi-select', CategoryMultiSelect);
Vue.component('v-crud-image-upload', ImageUpload);
Vue.component('v-crud-mail-preview', MailPreview);
Vue.component('v-crud-image', Image);
Vue.component('v-crud-translations', Translations);
Vue.component('v-crud-table', VueCrudTable);
Vue.component('v-crud-meta-data', MetaData);
Vue.component('order', Order);
Vue.component('messages', Messages);
Vue.component('payment', Payment);
Vue.component('shipping', Shipping);
Vue.component('automation', Automation);
Vue.component('general', General);
Vue.component('preview-image', PreviewImage);
Vue.component('chart-progress', ChartProgress);
Vue.component('v-custom-date-range-picker', CustomDateRangePicker);

Vue.filter('humanize', function (value) {
    if (typeof value === 'undefined') {
        return 'undefined';
    }
    var humanized = value
        .toString()
        .toLowerCase()
        .replace(/[_-]/g, ' ')
        .replace(/(?:^|\s)\S/g, function (a) {
            return a.toUpperCase();
        });

    return humanized;
});

Vue.filter('datetime', function (date) {
    if (typeof date === 'undefined' || date === null) {
        return '';
    }

    var dateObj = new Date(date);
    return dateObj.toLocaleDateString() + ' ' + dateObj.toLocaleTimeString();
});

Vue.filter('currency', Currency);

Vue.filter('date', function (date, format) {
    if (typeof date === 'undefined') {
        return '';
    }

    var dateObj = new Date(date);
    return dateObj.toLocaleDateString();
});

Vue.use(VueResource);
Vue.use(Router);
Vue.use(Wysiwyg, {
    hideModules: {
        image: true,
        table: true,
    },
});

let routerInstance = new Router({
    routes: [
        {
            path: '/logged_out',
            name: 'logged_out',
            component: LoggedOut,
        },
        {
            path: '/',
            name: 'home',
            component: Admin,
        },
        {
            path: '/admin/:model/:id/:action',
            name: 'admin',
            component: Admin,
            props: true,
        },
        {
            path: '/settings',
            name: 'settings',
            component: Admin,
            props: { model: 'settings', id: 'all', action: 'index' },
        },
    ],
});

Vue.http.options.headers = {
    Authorization: null,
};

export default routerInstance;



// WEBPACK FOOTER //
// ./src/router/index.js